import React from 'react';
import { Outlet } from 'react-router-dom';
import { StandardLayout } from 'spark-core-dx/components';
import { XChatDomainContextProvider } from './xChatProvider';
import { useCoreRoute } from 'spark-core-dx/hooks';

//Loads screens/items dynamically.
//No custom, always 1 to 1.

const XChatDomain = () => {
    const { getRoute } = useCoreRoute()
    window.MULTIVERX_API_AUTH_BASE_URL = getRoute("/multiverx/chat/", "XChat");
    return (
        <XChatDomainContextProvider>
            <StandardLayout>
                <Outlet />
            </StandardLayout>
        </XChatDomainContextProvider>
    );
};

export default XChatDomain;